import { CmsPagesPage } from './cms-pages/CmsPagesPage'
import { DesignSettingsPage } from './design-settings/DesignSettingsPage'

/**
 * `manager-marketing-site` — what the customer site says about the restaurant.
 *
 * Both ported: cms-pages, design-settings.
 *
 * **Two places store the same four fields.** `social_settings` and `design_settings` each hold
 * `restaurantName`, `facebookUrl`, `instagramUrl` and `mapEmbedUrl`, written by two different
 * requests from one save button — the design half through the theme context's debounced
 * `PUT /settings/design`, the social half directly. `/design` compares them and says when they
 * have drifted (FB-129).
 *
 * **The slug is the identity.** `PUT /cms-pages/{slug}` is an upsert on the slug and there is no
 * rename endpoint, so a page's address is chosen once and read-only after — saving under a new
 * one would leave two published pages rather than moving one (FB-125).
 */
export const managerMarketingSiteModule = {
  name: 'manager-marketing-site',
  routes: [
    {
      // *CMS Stránky* in the sidebar, under System settings. The nav gate is `cms` and carries no
      // tier module, so the route must not add one — a stricter route than its own link is a 404.
      path: '/cms',
      page: 'cms-pages',
      guard: { permission: 'cms' },
      component: CmsPagesPage,
    },
    {
      // *Design stránky* in the sidebar, gated on `design` with no tier module — legacy's own rule.
      // `GET /settings/social` admits `admin`; `PUT` is `main_admin` only, so the page says which
      // it is rather than telling an admin their change saved (FB-126).
      path: '/design',
      page: 'design-settings',
      guard: { permission: 'design' },
      component: DesignSettingsPage,
    },
  ],
} as const

export { CmsPagesPage, DesignSettingsPage }
